import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/tools/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsNCFileEventsStack = createStackNavigator();

const ToolsDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <ToolsDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <ToolsDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </ToolsDetailsNCFileEventsStack.Navigator>
  );
};

export { ToolsDetailsNCFileEventsNavigator };
